import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col, Badge, Card, Button } from 'react-bootstrap';
import './ServiceDetail.css';

const servicesData = {
    1: {
        title: "Sviluppo Web Frontend",
        description: "Creo interfacce utente moderne e responsive con React, Vue.js e tecnologie all'avanguardia per garantire la migliore user experience possibile.",
        fullDescription: `
      Nel mondo digitale di oggi, l'interfaccia utente è il primo punto di contatto tra il tuo business e i tuoi clienti. 
      Offro servizi di sviluppo frontend completi che combinano design accattivante, funzionalità avanzate e performance ottimali.
      
      Il mio approccio si basa su principi di design moderni e best practices di sviluppo, garantendo soluzioni che non solo 
      sembrano fantastiche, ma funzionano perfettamente su tutti i dispositivi e browser.
    `,
        technologies: ["React", "Vue.js", "TypeScript", "Sass/SCSS", "Webpack", "Vite"],
        features: [
            "Design Responsive e Mobile-First",
            "Componenti Riutilizzabili",
            "Ottimizzazione Performance",
            "Accessibilità Web (WCAG)",
            "SEO-Friendly",
            "Progressive Web App (PWA)",
            "Testing Automatizzato",
            "Cross-browser Compatibility"
        ],
        process: [
            "Analisi dei requisiti e wireframing",
            "Prototipazione interattiva",
            "Sviluppo componenti",
            "Testing e ottimizzazione",
            "Deploy e manutenzione"
        ],
        deliverables: [
            "Codice sorgente completo",
            "Documentazione tecnica",
            "Guida per la manutenzione",
            "3 mesi di supporto gratuito"
        ],
        // price: "A partire da €800",
        timeline: "2-4 settimane",
        icon: "🎨"
    },
    2: {
        title: "Sviluppo Backend",
        description: "API robuste e scalabili con Node.js, Python e database moderni per le tue applicazioni web e mobile.",
        fullDescription: `
      Il backend è il cuore pulsante di ogni applicazione moderna. Sviluppo soluzioni backend robuste, sicure e scalabili 
      che supportano la crescita del tuo business e garantiscono prestazioni eccellenti anche sotto carico elevato.
      
      Utilizzo architetture moderne e best practices di sicurezza per creare API che sono facili da mantenere, 
      documentare e integrare con qualsiasi frontend o applicazione mobile.
    `,
        technologies: ["Node.js", "Python", "Express", "FastAPI", "MongoDB", "PostgreSQL"],
        features: [
            "API RESTful e GraphQL",
            "Autenticazione e Autorizzazione",
            "Database Design e Ottimizzazione",
            "Caching e Performance",
            "Sicurezza Avanzata",
            "Monitoring e Logging",
            "Documentazione API",
            "Testing Unitario e Integrazione"
        ],
        process: [
            "Progettazione architettura",
            "Setup database e modelli",
            "Sviluppo API endpoints",
            "Implementazione sicurezza",
            "Testing e deploy"
        ],
        deliverables: [
            "API complete e documentate",
            "Database ottimizzato",
            "Dashboard di monitoring",
            "6 mesi di supporto tecnico"
        ],
        // price: "A partire da €1200",
        timeline: "3-6 settimane",
        icon: "⚙️"
    },
    3: {
        title: "E-commerce Solutions",
        description: "Sviluppo Magento 2, Magento 1/OpenMage, WooCommerce. Migrazione, moduli custom e integrazione con Odoo ERP.",
        fullDescription: `
      Specializzato nello sviluppo di e-commerce con Magento 2, supporto Magento 1/OpenMage e WooCommerce. 
      Offro servizi completi di migrazione da Magento 1.9 a OpenMage, sviluppo di moduli personalizzati 
      e integrazione avanzata con Odoo ERP per unificare e-commerce e gestione aziendale.
      
      Ogni soluzione è ottimizzata per performance, sicurezza e conversioni, con particolare attenzione 
      all'integrazione con sistemi gestionali per automatizzare processi di vendita, magazzino e contabilità.
    `,
        technologies: ["Magento 2", "OpenMage", "WooCommerce", "PHP", "MySQL", "Odoo ERP"],
        features: [
            "Sviluppo Magento 2 Enterprise",
            "Migrazione Magento 1.9 → OpenMage", 
            "WooCommerce Development",
            "Moduli Custom Magento",
            "Plugin WooCommerce",
            "Integrazione Odoo ERP",
            "Sincronizzazione Magazzino",
            "Automazione Ordini"
        ],
        process: [
            "Analisi piattaforma e requirements",
            "Setup e configurazione e-commerce",
            "Sviluppo moduli/plugin custom",
            "Integrazione con Odoo ERP",
            "Testing, migrazione e go-live"
        ],
        deliverables: [
            "E-commerce completo e funzionale",
            "Moduli custom sviluppati",
            "Integrazione Odoo operativa",
            "Documentazione e training",
            "12 mesi supporto e assistenza"
        ],
        // price: "A partire da €1500",
        timeline: "4-8 settimane",
        icon: "🛒"
    },
    4: {
        title: "Mobile App Development",
        description: "App native e cross-platform per iOS e Android con React Native e Flutter per raggiungere tutti i tuoi utenti.",
        fullDescription: `
      Sviluppo app mobile che offrono esperienze native su iOS e Android utilizzando le tecnologie cross-platform 
      più avanzate. Le mie app combinano performance native con il vantaggio di un unico codebase, riducendo tempi 
      e costi di sviluppo.
      
      Ogni app è progettata seguendo le linee guida di design di Apple e Google, garantendo un'esperienza utente 
      familiare e intuitiva su entrambe le piattaforme.
    `,
        technologies: ["React Native", "Flutter", "Expo", "Firebase", "Native Modules", "Push Notifications"],
        features: [
            "Design Nativo per iOS e Android",
            "Offline Functionality",
            "Push Notifications",
            "Integrazione Social Login",
            "Camera e Media Handling",
            "Geolocalizzazione",
            "In-App Purchases",
            "Analytics e Crash Reporting"
        ],
        process: [
            "Definizione requisiti e features",
            "Prototipazione e design",
            "Sviluppo app cross-platform",
            "Testing su dispositivi reali",
            "Pubblicazione su App Store e Play Store"
        ],
        deliverables: [
            "App iOS e Android",
            "Codice sorgente",
            "Documentazione tecnica",
            "Assistenza pubblicazione store"
        ],
        // price: "A partire da €2000",
        timeline: "6-10 settimane",
        icon: "📱"
    },
    5: {
        title: "UI/UX Design",
        description: "Design di interfacce intuitive e user experience ottimizzate per massimizzare le conversioni e la soddisfazione utente.",
        fullDescription: `
      Il design non è solo estetica, ma strategia. Creo interfacce che non solo sono belle da vedere, ma sono 
      progettate scientificamente per guidare gli utenti verso i tuoi obiettivi business, migliorando le conversioni 
      e la soddisfazione dell'utente.
      
      Il mio processo di design è centrato sull'utente, basato su ricerca, testing e iterazione continua per 
      garantire risultati misurabili e un ROI significativo sui tuoi investimenti digitali.
    `,
        technologies: ["Figma", "Adobe XD", "Sketch", "Principle", "InVision", "Miro"],
        features: [
            "User Research e Personas",
            "Information Architecture",
            "Wireframing e Prototyping",
            "Visual Design",
            "Design System Creation",
            "Usability Testing",
            "A/B Testing Design",
            "Responsive Design"
        ],
        process: [
            "Research e analisi utenti",
            "Wireframing e architettura",
            "Visual design e prototyping",
            "User testing e feedback",
            "Delivery e design system"
        ],
        deliverables: [
            "Design files completi",
            "Prototipi interattivi",
            "Design system",
            "Specifiche per sviluppatori"
        ],
        // price: "A partire da €600",
        timeline: "2-4 settimane",
        icon: "✨"
    },
    6: {
        title: "Consulenza Tecnica",
        description: "Analisi e ottimizzazione di progetti esistenti, architettura software e code review per migliorare performance e qualità.",
        fullDescription: `
      Offro consulenza tecnica specializzata per aiutare team e aziende a migliorare la qualità del loro codice, 
      ottimizzare le performance e implementare best practices di sviluppo. La mia esperienza span diverse tecnologie 
      e architetture software.
      
      Che tu abbia bisogno di un audit tecnico, di ottimizzare un'applicazione esistente o di definire l'architettura 
      per un nuovo progetto, fornisco insights pratici e soluzioni concrete per raggiungere i tuoi obiettivi.
    `,
        technologies: ["Code Review", "Performance Audit", "Security Analysis", "Architecture Design", "DevOps", "Monitoring"],
        features: [
            "Code Review Approfondito",
            "Performance Optimization",
            "Security Audit",
            "Architecture Consulting",
            "Best Practices Implementation",
            "Team Training",
            "Documentation Review",
            "Technology Stack Evaluation"
        ],
        process: [
            "Audit tecnico completo",
            "Identificazione problematiche",
            "Piano di miglioramento",
            "Implementazione soluzioni",
            "Training e knowledge transfer"
        ],
        deliverables: [
            "Report audit dettagliato",
            "Piano di ottimizzazione",
            "Documentazione migliorata",
            "Sessioni di training team"
        ],
        // price: "€80/ora",
        timeline: "Variabile",
        icon: "💡"
    }
};

function ServiceDetail() {
    const { id } = useParams();
    const service = servicesData[id];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    if (!service) {
        return (
            <Container className="py-5">
                <div className="text-center">
                    <h2>Servizio non trovato</h2>
                    <Link to="/" className="btn-gradient">Torna alla Home</Link>
                </div>
            </Container>
        );
    }

    return (
        <div className="service-detail-page">
            {/* Hero Section */}
            <section className="service-hero">
                <Container>
                    <Row className="align-items-center min-vh-50">
                        <Col lg={8} className="mx-auto text-center">
                            <div className="service-hero-icon">{service.icon}</div>
                            <h1 className="service-hero-title gradient-text">{service.title}</h1>
                            <p className="service-hero-description">{service.description}</p>
                            <div className="service-hero-meta">
                                {/* <Badge bg="primary" className="me-3">{service.price}</Badge> */}
                                <Badge bg="secondary">{service.timeline}</Badge>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Content Section */}
            <section className="service-content section-padding">
                <Container>
                    <Row>
                        <Col lg={8}>
                            <div className="service-description">
                                <h3>Descrizione Completa</h3>
                                <div className="description-text">
                                    {service.fullDescription.split('\n').map((paragraph, index) => (
                                        paragraph.trim() && <p key={index}>{paragraph.trim()}</p>
                                    ))}
                                </div>
                            </div>

                            <div className="service-features">
                                <h3>Caratteristiche Principali</h3>
                                <Row>
                                    {service.features.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">✓</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo di Lavoro</h3>
                                <div className="process-steps">
                                    {service.process.map((step, index) => (
                                        <div key={index} className="process-step-item">
                                            <div className="step-number">{index + 1}</div>
                                            <div className="step-text">{step}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Informazioni Progetto</h4>
                                        {/* <div className="info-item">
                                            <strong>Prezzo:</strong> {service.price}
                                        </div> */}
                                        <div className="info-item">
                                            <strong>Tempistiche:</strong> {service.timeline}
                                        </div>
                                        <div className="info-item">
                                            <strong>Tecnologie:</strong>
                                            <div className="tech-tags">
                                                {service.technologies.map((tech, index) => (
                                                    <Badge key={index} bg="light" text="dark" className="me-1 mb-1">
                                                        {tech}
                                                    </Badge>
                                                ))}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="deliverables-card">
                                    <Card.Body>
                                        <h4>Cosa Riceverai</h4>
                                        <ul className="deliverables-list">
                                            {service.deliverables.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <Button href="#contact" className="btn-gradient w-100 mb-3">
                                        Richiedi Preventivo
                                    </Button>
                                    <Link to="/" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default ServiceDetail;